import { getMertebeDisplay } from '../../utils/terminologyMap'

interface Props {
  mertebe_level?: string
  size?: 'sm' | 'md'
}

export default function MertebeBadge({ mertebe_level = 'NASUT', size = 'md' }: Props) {
  const d = getMertebeDisplay(mertebe_level)
  const isHahut = mertebe_level === 'HAHUT'
  const px = size === 'sm' ? '6px 10px' : '8px 14px'
  const fs = size === 'sm' ? 10 : 12

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      padding: px, borderRadius: 6, fontSize: fs, fontWeight: 600,
      color: d.color, background: d.bgColor,
      border: `1px solid ${d.color}30`,
      boxShadow: isHahut ? `0 0 8px ${d.color}40` : 'none',
    }}>
      {d.tier}
      <span style={{ fontSize: fs - 2, opacity: 0.7, fontWeight: 400 }}>
        {d.subtitle}
      </span>
    </span>
  )
}
